import React from "react";

interface DislikeIconProps {
    width?: string;
    height?: string;
    fill?: string;
    stroke?: string;
    onClick?: () => void;
    className?: string;
}

const DislikeIcon: React.FC<DislikeIconProps> = ({
    width = "28",
    height = "28",
    fill = "none",
    stroke = "currentColor",
    onClick,
    className
}) => (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M8.68086 15.5459C8.68086 16.0039 8.86218 16.4431 9.18472 16.767C9.38066 16.9637 9.61919 17.1073 9.87837 17.1903L12.9805 10.1808L12.9805 2.40316L10.2966 1.72937L5.24114 1.72937C5.2249 1.72937 5.20865 1.7286 5.19243 1.72768C4.82023 1.70649 4.45122 1.80758 4.14104 2.01524C3.83756 2.2184 3.60749 2.51347 3.48181 2.85685L1.77539 9.71029L1.76951 9.73306C1.71755 9.92011 1.7056 10.1218 1.73508 10.3183C1.76461 10.5148 1.83404 10.6924 1.92991 10.8369C2.02556 10.981 2.14157 11.0838 2.25994 11.1473C2.37728 11.2101 2.49835 11.2363 2.61433 11.2299C2.62999 11.229 2.64566 11.2282 2.66135 11.2282L7.82093 11.2282C8.29585 11.2282 8.68086 11.6148 8.68086 12.0917L8.68086 15.5459ZM17.2801 2.5929L14.7004 2.5929L14.7004 9.50115L17.2801 9.50115L17.2801 2.5929ZM6.961 12.9553L2.66135 12.9553C2.23857 12.9701 1.82322 12.8709 1.4504 12.6711C1.06488 12.4645 0.741259 12.1599 0.498934 11.7949C0.256886 11.4302 0.0999915 11.0118 0.0345409 10.5763C-0.0297195 10.1487 -0.00387873 9.70979 0.108441 9.29286L0.1076 9.29201L1.82746 2.38376C1.83394 2.35774 1.84127 2.33148 1.85013 2.30618C2.0975 1.59994 2.56673 0.993548 3.18705 0.57827C3.79393 0.171988 4.51326 -0.0279477 5.24114 0.00314402L5.24114 0.00230097L10.4007 0.00230142C10.471 0.00230142 10.5408 0.0113518 10.609 0.0284436L13.9446 0.865833L17.2801 0.865833C17.7363 0.865833 18.1736 1.04792 18.4961 1.37181C18.8187 1.6957 19 2.13485 19 2.5929L19 9.50115C19 9.9592 18.8187 10.3984 18.4961 10.7222C18.1736 11.0461 17.7363 11.2282 17.2801 11.2282L14.3997 11.2282L11.1867 18.4873L11.1271 18.5986C10.9711 18.846 10.6981 19 10.4007 19C9.48844 19 8.6138 18.6358 7.96873 17.988C7.32365 17.3403 6.961 16.462 6.961 15.5459L6.961 12.9553Z" fill="currentColor"/>
</svg>



);

export default DislikeIcon;
